<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<div class="modal-body gt-dashboard-ex-body" [hidden]="minimise" [ngClass]="currentTheme">
  @if (!loading && submissions.length > 0) {
<div class="table-container">
    <div class="table-toolbar">
      <div class="toolbar-left">
        <button type="button" class="toolbar-btn" title="Print" (click)="printTable()">
          <i class="fa fa-print" aria-hidden="true"></i>
        </button>
        <button type="button" class="toolbar-btn" title="Excel" (click)="exportToExcel()">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
        </button>
      </div>
      <div class="toolbar-right">
        <label class="toolbar-search-label">
          Search:
          <input
            type="search"
            class="toolbar-search-input"
            name="dashboardPopupSearch"
            [ngModel]="searchQuery"
            (ngModelChange)="onSearchChange($event)"
            aria-label="Search table"
          />
        </label>
      </div>
    </div>
    <div class="table-body-scroll">
      <table class="dashboard-table">
        <thead>
          <tr>
            @for (col of columns; track $index) {
<th
                [hidden]="col.visible === false"
                [class.sortable]="isSortable(col)"
                [class.sorted]="isSortable(col) && sortKey === col.data"
                [attr.tabindex]="isSortable(col) ? 0 : null"
                [attr.role]="isSortable(col) ? 'button' : null"
                [attr.aria-sort]="
                  !isSortable(col) || sortKey !== col.data
                    ? null
                    : (sortDir === 'asc' ? 'ascending' : 'descending')
                "
                (click)="toggleSort(col)"
                (keyup.enter)="toggleSort(col)">
              <span class="dashboard-popup-cell-text">{{ col.title }}</span>
              @if (isSortable(col)) {
<i
                 class="sort-icon"
                 [ngClass]="sortIconClass(col)"
                 aria-hidden="true"></i>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @if (displaySubmissions.length === 0) {
<tr>
            <td [attr.colspan]="columns.length" class="no-match">
              No matching records found.
            </td>
          </tr>
}
          <!--
            Cell rendering mirrors `efileFactory.submissionListColumns`
            (EfileService.js L86-103): file columns flagged with
            `downloadType` are wrapped in an `<a>` that triggers the
            download, the Acknowledgement column turns red when its value
            is the string "No", and "Submitted Date" is formatted the
            same way the legacy template did via `$filter('date')`.
          -->
          @for (row of displaySubmissions; track $index) {
<tr>
            @for (col of columns; track $index) {
<td [hidden]="col.visible === false">
              @if (col.downloadType) {

                @if (row[col.data] != null && row[col.data] !== '') {
<a
                   class="dashboard-popup-cell-link"
                   [class.text-red]="col.ackRedOnNo && row[col.data] === 'No'"
                   (click)="downloadFile(col.downloadType, row.IRS_ID)">
                  {{ row[col.data] }}
                </a>
} @else {

                  <span class="dashboard-popup-cell-text"></span>
                
}
                
              
} @else {

                <span class="dashboard-popup-cell-text">{{ formatCell(row, col) }}</span>
              
}
              
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
}

  @if (!loading && submissions.length === 0) {
<div class="no-data">
    No submissions found.
  </div>
}

  @if (loading) {
<div class="loader">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </div>
}
</div>

@if (showConfirmDialog) {
<div class="confirm-overlay" (click)="onCancelConfirm()">
  <div class="confirm-dialog" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Confirm</h3>
      <div class="header-actions">
        <i (click)="onCancelConfirm()" class="fa fa-times"></i>
      </div>
    </div>
    <div class="modal-body">
      <p>{{confirmMessage}}</p>
    </div>
    <div class="modal-footer">
      <button class="save-button" type="button" (click)="onConfirm()">Yes</button>
      <button class="cancel-button" type="button" (click)="onCancelConfirm()">No</button>
    </div>
  </div>
</div>
}
